import { render } from "./price_change_confirmation.vue?vue&type=template&id=14a76623"
import script from "./price_change_confirmation.vue?vue&type=script&lang=js"
export * from "./price_change_confirmation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__